import { FunctionComponent, useState } from 'react'
import CollectionActionLabel from '@/components/common/collection-action-label'
import NoStyleNativeButton from '@/components/common/no-style-button'

type RemoveKolsFromCollectionLabelProps = {
  onClick: () => void
}

const RemoveKolsFromCollectionLabel: FunctionComponent<
  RemoveKolsFromCollectionLabelProps
> = ({ onClick }) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <NoStyleNativeButton
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering ? (
        <CollectionActionLabel type='cancel' />
      ) : (
        <CollectionActionLabel type='added' />
      )}
    </NoStyleNativeButton>
  )
}

export default RemoveKolsFromCollectionLabel
